import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import "../Landing.scss";
import "../ln.scss";
import axios from "axios";
import url from "../../../url.json";
import headers from "../../../config/headers.js";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { getprofilAsync } from "../../../Redux/Reducers/Profil/profilSlice.js";
import { IsLegalReducer } from "../../../Redux/Reducers/IsLegal/IsLegal";
import { tokenReducer } from "../../../Redux/Reducers/Token/TokenReducer";
import { isEdsLoginState } from "../../../config/eds";
import { PHONES, EMAIL } from "../LandingHead/LandingHead";

const ACCENT = "#0F766E";
const INK = "#0F5F58";

const Check = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10" /></svg>
);

const Icon = ({ d, size = 20, width = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={INK} strokeWidth={width} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {d}
  </svg>
);

// Admin'dagi rangli ikonkalar o'rniga dizayndagi chiziqli ikonkalar (nom bo'yicha)
const SOCIAL_ICONS = {
  instagram: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <path d="M17.5 6.5h.01" />
    </>
  ),
  facebook: <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />,
  telegram: (
    <>
      <path d="M22 2 11 13" />
      <path d="M22 2 15 22l-4-9-9-4z" />
    </>
  ),
  youtube: (
    <>
      <rect x="2" y="5" width="20" height="14" rx="4" />
      <path d="M10 9l5 3-5 3z" />
    </>
  ),
};

const STAGES = [1, 2, 3, 4, 5];

const VIDEOS = [
  { title: "Title1", id: "HXyKRDB3y5g" },
  { title: "Title2", id: "OtyRTmHT0jY" },
  { title: "Title3", id: "YlYVlbga_Lk" },
  { title: "Title4", id: "fSdu3eEZ6Ak" },
  { title: "Title5", id: "Cpx48ZLUfTc" },
  { title: "Title6", id: "nLk7RlFJ0cc" },
];

const formatDate = (value) => {
  if (!value) return "";
  const [y, m, d] = String(value).slice(0, 10).split("-");
  return d && m && y ? `${d}.${m}.${y}` : value;
};

const isValid = (endDate) => !endDate || new Date(endDate) >= new Date(new Date().toDateString());

function HomeLand({ t }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [about, setAbout] = useState();
  const [article, setArticle] = useState();
  const [faqs, setFaqs] = useState();
  const [contacts, setContacts] = useState();
  const lan = useSelector((state) => state.langReducer);
  const namref = useRef(null);
  const emailref = useRef(null);
  const messageref = useRef(null);
  const [searchParams] = useSearchParams();
  const loggedIn = !!localStorage.getItem("token");

  // Boshqa sahifadan "/#contact" kabi kelinganda — o'sha bo'limga, aks holda tepaga
  useEffect(() => {
    const id = location.hash.replace("#", "");
    if (!id) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 300);
    return () => clearTimeout(timer);
  }, [location.hash]);

  useEffect(() => {
    if (searchParams.get("code") && isEdsLoginState(searchParams.get("state"))) {
      // ЭЦП orqali kirish (login sahifasidagi tugma)
      axios
        .post(url.url + "/auth/eds-login", { code: searchParams.get("code") }, { headers: headers() })
        .then((res) => {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.user));
          dispatch(tokenReducer(res.data.token));
          dispatch(IsLegalReducer(res.data.user.legal_entity));
          dispatch(getprofilAsync("legal-entity/profile"));
          window.location.href = res.data.user.legal_entity == null ? "/register/last-step" : "/account/applications";
        })
        .catch((err) => {
          toast.error(err.response?.data?.errors?.message?.[0] || t("ERI login failed"));
          navigate("/login");
        });
    } else if (searchParams.get("code")) {
      const data = {
        code: searchParams.get("code"),
      };
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("token")}`;
      axios
        .post(url.url + "/eds", data, { headers: headers() })
        .then((res) => {
          toast.success(res.data.data.message);
          dispatch(getprofilAsync("legal-entity/profile"));
          navigate("/account/applications");
        })
        .catch((err) => {
          toast.error(err.response.data.error.message);

          navigate("/register/last-step");
        });
    }
  }, [searchParams.get("code")]);

  useEffect(() => {
    axios.get(url.url + "/about", { headers: headers() }).then((res) => {
      setAbout(res.data.data);
    });
    axios.get(url.url + "/article", { headers: headers() }).then((res) => {
      setArticle(res.data);
    });
    axios.get(url.url + "/faqs", { headers: headers() }).then((res) => {
      setFaqs(res.data.data?.result);
    });
    axios.get(url.url + "/contact", { headers: headers() }).then((res) => {
      setContacts(res.data.data);
    });
  }, [lan.value]);

  //* hero tracker
  const [stage, setStage] = useState(2);

  //* registry preview
  const [regQuery, setRegQuery] = useState("");
  const [regRows, setRegRows] = useState();
  const [regLoading, setRegLoading] = useState(true);
  const loadRegistry = (q = "") => {
    const params = new URLSearchParams({ page: 1 });
    const query = q.trim();
    if (query) {
      // VP-002367 kabi qiymat — guvohnoma raqami, qolgani — nomi
      params.append(/^[A-Za-z]{1,4}[-\s]?\d+/.test(query) ? "number" : "name", query);
    }
    setRegLoading(true);
    axios
      .get(`${url.url}/certificate-registry?${params.toString()}`, { headers: headers() })
      .then((res) => {
        const data = res.data?.data || res.data;
        setRegRows((data?.result || []).slice(0, 4));
      })
      .catch(() => setRegRows([]))
      .finally(() => setRegLoading(false));
  };
  useEffect(() => {
    loadRegistry();
  }, [lan.value]);

  //* videos: iframe faqat bosilganda yuklanadi
  const [playing, setPlaying] = useState(null);

  //* contact form
  const [error, seterror] = useState();
  const [sending, setSending] = useState(false);
  const handeSave = (e) => {
    e.preventDefault();
    if (sending) return;
    const data = {
      full_name: namref.current.value.trim(),
      email: emailref.current.value.trim(),
      message: messageref.current.value.trim(),
    };

    setSending(true);
    axios
      .post(url.url + "/contactmessage", data, { headers: headers() })
      .then((res) => {
        toast.success(res.data.message);
        document.getElementById("form_contact").reset();
        seterror();
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status == 422) seterror(err.response.data.errors);
        else if (status == 429) toast.error(t("too many requests"));
        else toast.error(err.response?.data?.message || t("Something went wrong"));
      })
      .finally(() => setSending(false));
  };

  const socials = (contacts || []).filter((c) => c.type != "phone" && c.icon);
  const lat = about?.point_x;
  const lon = about?.point_y;

  return (
    <div className="ln">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Home")}</title>
        <meta name="description" content={t("ln_hero_text")} />
      </Helmet>

      {/* Hero */}
      <section id="top" className="ln-hero">
        <div className="ln-wrap">
          <div className="ln-hero__main">
            <span className="ln-badge">{t("ln_hero_badge")}</span>
            <h1 className="ln-hero__title">
              {t("ln_hero_title_1")} <span className="accent">{t("ln_hero_title_accent")}</span>.
              <br />
              <span className="muted">{t("ln_hero_title_2")}</span>
            </h1>
            <p className="ln-hero__text">{t("ln_hero_text")}</p>
            <div className="ln-hero__ctas">
              <Link
                to={loggedIn ? "/account/applications" : "/login"}
                className="ln-btn ln-btn_primary ln-btn_lg"
              >
                {t("ln_apply")}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
              </Link>
              <a href="#video" className="ln-btn ln-btn_outline ln-btn_lg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M10 8l6 4-6 4z" /></svg>
                {t("Video guide")}
              </a>
            </div>
            <span className="ln-hero__note">{t("ln_hero_note")}</span>
          </div>

          <div className="ln-tracker">
            <div className="ln-tracker__head">
              <div>
                <span className="ln-tracker__label">{t("ln_tracker_label")}</span>
                <span className="ln-tracker__title">{t("ln_tracker_title")}</span>
              </div>
              <span className="ln-pill ln-pill_warn">{t(`ln_stage_${STAGES[stage]}`)}</span>
            </div>
            <ol className="ln-tracker__list">
              {STAGES.map((n, i) => (
                <li key={n}>
                  <button
                    type="button"
                    onClick={() => setStage(i)}
                    className={clsx("ln-stage", i === stage && "is-current", i > stage && "is-pending")}
                  >
                    {i < stage ? (
                      <span className="ln-stage__dot ln-stage__dot_done">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10" /></svg>
                      </span>
                    ) : i === stage ? (
                      <span className="ln-stage__dot ln-stage__dot_current">
                        <span />
                      </span>
                    ) : (
                      <span className="ln-stage__dot ln-stage__dot_pending" />
                    )}
                    <span className="ln-stage__text">
                      <strong>{t(`ln_stage_${n}`)}</strong>
                      <small>{t(`ln_stage_${n}_note`)}</small>
                    </span>
                  </button>
                </li>
              ))}
            </ol>
            <span className="ln-tracker__hint">{t("ln_tracker_hint")}</span>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="ln-benefits">
        <div className="ln-wrap">
          <div className="ln-feature">
            <span className="ln-ico"><Icon d={<><rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8M12 17v4" /></>} /></span>
            <span><strong>{t("ln_ben_1")}</strong><small>{t("ln_ben_1_text")}</small></span>
          </div>
          <div className="ln-feature">
            <span className="ln-ico"><Icon d={<path d="M3 12h4l3-7 4 14 3-7h4" />} /></span>
            <span><strong>{t("ln_ben_2")}</strong><small>{t("ln_ben_2_text")}</small></span>
          </div>
          <div className="ln-feature">
            <span className="ln-ico"><Icon d={<><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5" /><path d="M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" /></>} /></span>
            <span><strong>{t("ln_ben_3")}</strong><small>{t("ln_ben_3_text")}</small></span>
          </div>
          <div className="ln-feature">
            <span className="ln-ico"><Icon d={<><path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8z" /><path d="M14 3v5h5M9 14l2 2 4-4" /></>} /></span>
            <span><strong>{t("ln_ben_4")}</strong><small>{t("ln_ben_4_text")}</small></span>
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services">
        <div className="ln-wrap ln-intro">
          <span className="ln-eyebrow">{t("ln_services_label")}</span>
          <h2 className="ln-h2">{t("ln_services_title")}</h2>
        </div>

        <div className="ln-wrap ln-split">
          <div className="ln-col">
            <h3 className="ln-h3">{t("ln_svc_app_title")}</h3>
            <p className="ln-lead">{t("ln_svc_app_text")}</p>
            <ul className="ln-checks">
              {[1, 2, 3, 4].map((n) => (
                <li key={n}><Check />{t(`ln_svc_app_${n}`)}</li>
              ))}
            </ul>
          </div>
          <div className="ln-mock" aria-hidden="true">
            <strong>{t("ln_my_apps")}</strong>
            <div className="ln-mock__row"><span>{t("ln_demo_1")}</span><span className="ln-pill ln-pill_warn">{t("ln_status_review")}</span></div>
            <div className="ln-mock__row"><span>{t("ln_demo_2")}</span><span className="ln-pill ln-pill_ok">{t("ln_status_issued")}</span></div>
            <div className="ln-mock__row"><span>{t("ln_demo_3")}</span><span className="ln-pill ln-pill_mute">{t("ln_status_contract")}</span></div>
          </div>
        </div>

        <div id="registry" className="ln-wrap ln-split ln-split_reverse">
          <div className="ln-registry">
            <form
              className="ln-registry__form"
              onSubmit={(e) => {
                e.preventDefault();
                loadRegistry(regQuery);
              }}
            >
              <div className="ln-field">
                <label htmlFor="reg-q">{t("ln_reg_search_label")}</label>
                <input
                  id="reg-q"
                  type="search"
                  value={regQuery}
                  onChange={(e) => setRegQuery(e.target.value)}
                  placeholder={t("ln_reg_search_ph")}
                />
              </div>
              <button type="submit" className="ln-btn ln-btn_dark" disabled={regLoading}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
                {t("ln_search")}
              </button>
            </form>
            <div className="ln-table-wrap">
              <table className="ln-table">
                <thead>
                  <tr>
                    <th>{t("ln_col_product")}</th>
                    <th>{t("ln_col_type")}</th>
                    <th>{t("ln_col_cert")}</th>
                    <th>{t("ln_col_status")}</th>
                  </tr>
                </thead>
                <tbody>
                  {regLoading ? (
                    [0, 1, 2].map((i) => (
                      <tr key={i}>
                        {[0, 1, 2, 3].map((j) => (
                          <td key={j}><span className="ln-skel" /></td>
                        ))}
                      </tr>
                    ))
                  ) : regRows?.length ? (
                    regRows.map((row) => (
                      <tr key={row.id}>
                        <td>{row.drug_name}</td>
                        <td>{row.drug_type_name || "—"}</td>
                        <td>{row.number || "—"}</td>
                        <td>
                          {isValid(row.end_date) ? (
                            <span className="ln-pill ln-pill_ok">
                              {t("ln_valid")}{row.end_date ? ` · ${formatDate(row.end_date)}` : ""}
                            </span>
                          ) : (
                            <span className="ln-pill ln-pill_warn">{t("ln_expired")}</span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="ln-table__empty">{t("ln_reg_empty")}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <Link to="/reestr-new" className="ln-link-strong">{t("ln_reg_open")}</Link>
          </div>
          <div className="ln-col">
            <h3 className="ln-h3">{t("ln_reg_title")}</h3>
            <p className="ln-lead">{t("ln_reg_text")}</p>
            <ul className="ln-checks">
              {[1, 2, 3].map((n) => (
                <li key={n}><Check />{t(`ln_reg_${n}`)}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Steps */}
      <section id="steps" className="ln-steps">
        <div className="ln-wrap">
          <div className="ln-steps__head">
            <div>
              <span className="ln-eyebrow">{t("ln_nav_steps")}</span>
              <h2 className="ln-h2">{t("ln_steps_title")}</h2>
            </div>
            {!loggedIn ? (
              <Link to="/register/frist-step" className="ln-btn ln-btn_primary">{t("Sign up")}</Link>
            ) : (
              ""
            )}
          </div>
          <div className="ln-grid">
            {[
              ["ln_stage_1", "ln_step_1_text"],
              ["ln_apply", "ln_step_2_text"],
              ["ln_stage_4", "ln_step_3_text"],
              ["ln_col_cert", "ln_step_4_text"],
            ].map(([title, text], i) => (
              <div key={i} className="ln-step">
                <span className="ln-step__num">{i + 1}</span>
                <h3>{t(title)}</h3>
                <p>{t(text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About + quick links */}
      <section id="about">
        <div className="ln-wrap ln-about">
          <div className="ln-about__main">
            <span className="ln-eyebrow">{t("About")}</span>
            <h2 className="ln-h2">{t("ln_about_title")}</h2>
            <p className="ln-lead">{t("ln_about_text")}</p>
          </div>
          <div className="ln-about__cards">
            {[1, 2, 3].map((n) => (
              <div key={n} className="ln-card">
                <h3>{t(`ln_about_${n}`)}</h3>
                <p>{t(`ln_about_${n}_text`)}</p>
              </div>
            ))}
          </div>
        </div>

        <div id="docs" className="ln-wrap ln-quick">
          <Link to="/reestr-new" className="ln-quick__item">
            <span className="ln-quick__ico"><Icon size={22} width={1.8} d={<><path d="M4 4h16v16H4z" /><path d="M8 9h8M8 13h8M8 17h5" /></>} /></span>
            <span><strong>{t("Reestr")}</strong><small>{t("ln_ql_reg_text")}</small></span>
          </Link>
          <Link to="/regulations" className="ln-quick__item">
            <span className="ln-quick__ico"><Icon size={22} width={1.8} d={<><path d="M4 19V5a2 2 0 0 1 2-2h12v18H6a2 2 0 0 1-2-2z" /><path d="M8 7h6" /></>} /></span>
            <span><strong>{t("Regulations")}</strong><small>{t("ln_ql_docs_text")}</small></span>
          </Link>
          <Link to="/faq" className="ln-quick__item">
            <span className="ln-quick__ico"><Icon size={22} width={1.8} d={<><circle cx="12" cy="12" r="10" /><path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .9-1 1.7M12 17h.01" /></>} /></span>
            <span><strong>{t("FAQ")}</strong><small>{t("ln_ql_faq_text")}</small></span>
          </Link>
          <a href="#video" className="ln-quick__item">
            <span className="ln-quick__ico"><Icon size={22} width={1.8} d={<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M10 9l5 3-5 3z" /></>} /></span>
            <span><strong>{t("Video guide")}</strong><small>{t("ln_ql_video_text")}</small></span>
          </a>
        </div>
      </section>

      {/* Video guide */}
      <section id="video" className="ln-video">
        <div className="ln-wrap">
          <div className="ln-intro" style={{ padding: 0 }}>
            <span className="ln-eyebrow">{t("ln_ql_video_text")}</span>
            <h2 className="ln-h2">{t("Video guide")}</h2>
            <p className="ln-lead">{t("ln_video_text")}</p>
          </div>
          <div className="ln-grid" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))" }}>
            {VIDEOS.map((v) => (
              <div key={v.id} className="ln-video__card">
                <div className="ln-video__frame">
                  {playing === v.id ? (
                    <iframe
                      src={`https://www.youtube.com/embed/${v.id}?autoplay=1`}
                      title={t(v.title)}
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    />
                  ) : (
                    <>
                      <img src={`https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`} alt="" loading="lazy" />
                      <button type="button" className="ln-video__play" aria-label={t(v.title)} onClick={() => setPlaying(v.id)} />
                    </>
                  )}
                </div>
                <h3>{t(v.title)}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News + FAQ */}
      <section id="news" className="ln-news">
        <div className="ln-wrap">
          <div className="ln-news__main">
            <h2 className="ln-h2">{t("News")}</h2>
            <div className="ln-grid">
              {article?.data?.length
                ? article.data.slice(0, 4).map((res) => (
                    <article
                      key={res.id}
                      className="ln-article"
                      onClick={() => navigate(`/blogopen?id=${res.id}`)}
                    >
                      <div className="ln-article__img">
                        {res.image ? <img src={res.image} alt="" loading="lazy" /> : ""}
                      </div>
                      <div className="ln-article__body">
                        <span>{formatDate(res.date)}</span>
                        <h3>
                          <Link to={`/blogopen?id=${res.id}`} style={{ color: "inherit" }}>
                            {res.title}
                          </Link>
                        </h3>
                      </div>
                    </article>
                  ))
                : [0, 1].map((i) => (
                    <div key={i} className="ln-article" style={{ cursor: "default" }}>
                      <div className="ln-article__img" />
                      <div className="ln-article__body">
                        <span className="ln-skel" style={{ width: 80 }} />
                        <span className="ln-skel" />
                      </div>
                    </div>
                  ))}
            </div>
          </div>

          <div id="faq" className="ln-faq">
            <h2 className="ln-h2">{t("FAQ")}</h2>
            {(faqs || []).slice(0, 3).map((res) => (
              <details key={res.id}>
                <summary>{res.question}</summary>
                <p>{res.answer}</p>
              </details>
            ))}
            <Link to="/faq" className="ln-link-strong" style={{ fontSize: 15, marginTop: 4 }}>
              {t("ln_faq_all")}
            </Link>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact">
        <div className="ln-wrap ln-contact">
          <div className="ln-contact__info">
            <div>
              <span className="ln-eyebrow">{t("Contact")}</span>
              <h2 className="ln-h2">{t("ln_contact_title")}</h2>
              <p className="ln-lead">{t("ln_contact_text")}</p>
            </div>
            {about?.address ? (
              <div className="ln-contact__row" style={{ alignItems: "flex-start" }}>
                <Icon size={22} width={1.8} d={<><path d="M12 22s7-6.2 7-12a7 7 0 0 0-14 0c0 5.8 7 12 7 12z" /><circle cx="12" cy="10" r="2.5" /></>} />
                <span>{about.address}</span>
              </div>
            ) : (
              ""
            )}
            <div className="ln-contact__row">
              <Icon size={22} width={1.8} d={<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2" />} />
              <span className="ln-contact__phones">
                {PHONES.map((p) => (
                  <a key={p.value} href={`tel:${p.value}`}>{p.label}</a>
                ))}
              </span>
            </div>
            <div className="ln-contact__row">
              <Icon size={22} width={1.8} d={<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></>} />
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </div>
            <div className="ln-contact__row">
              <Icon size={22} width={1.8} d={<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>} />
              <span>{t("ln_hours_long")}</span>
            </div>
            {socials.length ? (
              <div className="ln-social-block">
                <span className="ln-social-block__label">{t("ln_follow")}</span>
                <div className="ln-social-list">
                  {socials.map((s) => {
                    const icon = SOCIAL_ICONS[s.name?.toLowerCase()];
                    return (
                      <a key={s.id} className="ln-social" href={s.value} target="_blank" rel="noopener noreferrer">
                        <span className="ln-social__ico">
                          {icon ? (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{icon}</svg>
                          ) : (
                            <img src={s.icon} alt="" width={18} height={18} />
                          )}
                        </span>
                        {s.name}
                      </a>
                    );
                  })}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

          <form id="form_contact" className="ln-contact__form" onSubmit={handeSave} noValidate>
            <div className={clsx("ln-field", error?.full_name && "has-error")}>
              <label htmlFor="fc-name">{t("fullname")}</label>
              <input id="fc-name" name="full_name" type="text" ref={namref} maxLength={255} />
              {error?.full_name ? <i>{error.full_name}</i> : ""}
            </div>
            <div className={clsx("ln-field", error?.email && "has-error")}>
              <label htmlFor="fc-email">{t("email")}</label>
              <input id="fc-email" name="email" type="email" ref={emailref} maxLength={255} />
              {error?.email ? <i>{error.email}</i> : ""}
            </div>
            <div className={clsx("ln-field ln-contact__full", error?.message && "has-error")}>
              <label htmlFor="fc-msg">{t("message")}</label>
              <textarea id="fc-msg" name="message" rows={5} ref={messageref} maxLength={5000} placeholder={t("write your message here")} />
              {error?.message ? <i>{error.message}</i> : ""}
            </div>
            <div className="ln-contact__submit">
              <span>{t("ln_contact_note")}</span>
              <button type="submit" className="ln-btn ln-btn_primary" disabled={sending}>
                {sending ? t("sending") : t("submit")}
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Map */}
      <section id="location">
        <div className="ln-wrap ln-map">
          <div className="ln-map__box">
            {lat && lon ? (
              <iframe
                title={t("ln_our_address")}
                // Yandex vidjeti: Google embed'dagi "Ilmiy markaz" joy kartochkasi chiqmaydi
                src={`https://yandex.uz/map-widget/v1/?ll=${lon},${lat}&z=16&pt=${lon},${lat},pm2rdm&lang=${lan.value == "en" ? "en_US" : lan.value == "ru" ? "ru_RU" : "uz_UZ"}`}
                loading="lazy"
                allowFullScreen
              />
            ) : (
              ""
            )}
            <div className="ln-map__card">
              <span className="ln-eyebrow">{t("ln_our_address")}</span>
              <strong>{about?.address}</strong>
              <small>{t("ln_hours_short")}</small>
              {lat && lon ? (
                <div>
                  <a
                    className="ln-btn ln-btn_primary"
                    href={`https://yandex.uz/maps/?pt=${lon},${lat}&z=16&l=map`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("ln_open_yandex")}
                  </a>
                  <a
                    className="ln-btn ln-btn_outline"
                    href={`https://www.google.com/maps/search/?api=1&query=${lat},${lon}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Google Maps
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default withTranslation()(HomeLand);
